export default {
    navbar: {
        login: '登录',
        merchantCenter: '商家中心',
        myCart: '我的购物车',
        myOrders: '我的订单',
        accountInfo: '账户信息',
        logout: '退出',
        welcome: '欢迎体验',
        language: '中文',
        newsCenter: '新闻中心',
        mall: '算力市场',
        aiService: 'AI服务',
        product: 'IT硬件',
        about: '关于我们',
        introduction: '公司介绍',
        recruit: '招贤纳士',
        contact: '联系我们',
        industry: '按行业',
        region: '按区域',
        bareMetal: '裸金属服务',
        aiMachineLearning: 'AI/机器学习',
        finance: '金融',
        medical: '医疗',
        education: '教育',
        cardTimeCapacity: '卡时容量服务',
        tokenService: 'Token服务',
        traditionalPowerService: '传统算力服务',
        dataAnalysis: '数据分析',
        websiteHosting: '网站托管',
        database: '数据库',
        developmentTest: '开发测试',
        dataAnnotation: '数据标注',
        dataSet: '数据集',
        industryData: '行业数据',
        frameworkPackage: '框架及包',
        industryModelFineTuning: '行业模型微调服务',
        modelStructure: '模型结构',
        learningStrategy: '学习策略',
        dataPreprocessing: '数据预处理',
        parameter: '参数',
        maasModelService: 'MaaS模型服务',
        nlp: '自然语言处理',
        computerVision: '计算机视觉',
        multiModal: '多模态',
        speech: '语音',
        industryIntelligence: '行业智能',
        server: '服务器',
        aiSupercomputer: 'AI超算服务器',
        edgeServer: '边缘服务器',
        armServer: 'Arm 服务器',
        towerServer: '塔式服务器',
        highDensityServer: '高密度服务器',
        rackServer: '机架服务器',
        terminal: '终端',
        game: '游戏',
        videoProcessing: '视频处理',
        rendering: '渲染',
        scientificComputing: '科学计算',
        accessory: '配件',
        recommendSystem: '推荐系统',
        other: '其他',
        northChina: '华北',
        eastChina: '华东',
        southChina: '华南',
        southwest: '西南',
      },
      news: {
        searchResult: '检索结果',
        searchPlaceholder: '请输入新闻关键字',
        date: '{date}',
        noNews: '暂无新闻',
        tablist: {
          latest: '最新动态',
          case: '典型案例',
          notice: '通知公告',
        }
      }
} 